export default {
  title: 'Katalog her',
  subtitle: 'Procházejte ověřené digitální herní klíče. Okamžité doručení. Nepřekonatelné ceny.',
  priceAny: 'Libovolná cena',
  priceUnder10: 'Do €10',
  price10to30: '€10 – €30',
  price30to60: '€30 – €60',
  price60plus: '€60+',
  pricePlaceholder: 'Cena',
  sortRelevance: 'Relevance',
  sortNewest: 'Nejnovější',
  sortPriceAsc: 'Cena: od nejnižší',
  sortPriceDesc: 'Cena: od nejvyšší',
  sortNameAsc: 'Název: A–Z',
  platformPlaceholder: 'Platforma',
  genrePlaceholder: 'Žánr',
  sortBy: 'Řadit podle:',
  activeFilters: 'Aktivní filtry:',
  clearAll: 'Vymazat vše',
  results: '{count} her',
  throttledTitle: 'Spojení omezeno',
  throttledBody: 'Příliš mnoho požadavků — počkejte prosím chvíli a zkuste to znovu. Naše servery jsou momentálně velmi vytížené.',
  unavailableTitle: 'Katalog není dostupný',
  unavailableBody: 'Nepodařilo se připojit ke katalogovému API. Spusťte backend a poté to zkuste znovu.',
  noResultsTitle: 'Žádné nabídky nenalezeny',
  noResultsBody: 'Nepodařilo se nám najít žádné produkty odpovídající vašim aktuálním filtrům. Zkuste upravit parametry vyhledávání.',
  clearFilters: 'Vymazat filtry',
  outOfStock: 'Není skladem',
  view: 'Zobrazit',
  unavailable: 'Nedostupné',
  addToWishlist: 'Přidat do oblíbených',
  // Terminal catalog page
  titlesDetected: 'Titulů nalezeno',
  searchDb: 'Hledat v databázi',
  sortPopularity: 'Popularita',
  addToCart: 'Do košíku',
  baseGame: 'Základní hra',
  dlc: 'DLC',
  prev: 'Předchozí',
  next: 'Další',
};
